import GoogleTranslate from "../components/googleTranslate";
import "../styles/header.css";
import * as Config from "../lib/config";
import Image from "../components/Image";
import { Navbar, Nav } from "react-bootstrap";
import { useState, useEffect } from "react";
// import { Link } from "react-scroll";
import { Link as ScrollLink } from "react-scroll";
import { RedirectLink } from "../components/redirectLink/redirect";
const Header = () => {
  const [expanded, setExpanded] = useState(false);
  const [theme, setTheme] = useState(() => {
    return localStorage.getItem("theme") || "light";
  });

  useEffect(() => {
    document.documentElement.setAttribute("data-theme", theme);
    localStorage.setItem("theme", theme);
  }, [theme]);

  const toggleTheme = () => {
    setTheme((prevTheme) => (prevTheme === "light" ? "dark" : "light"));
  };
  return (
    <>
      <Navbar expand="lg" expanded={expanded}>
        <div className="container headerContainer py-md-0 py-1">
          <Navbar.Brand>
            <div className="navbar-brand d-flex align-items-center">
              <Image
                alt="AR Drawing logo placeholder image"
                height="46"
                src={Config.images.appIcon}
                width="46"
                className="rounded-4"
                loading="eager"
                fetchpriority="high"
              />
              <div className=" pl-2">
                <span className=" m-0">AR</span> Drawing
              </div>
            </div>
          </Navbar.Brand>
          <Navbar.Toggle
            aria-controls="basic-navbar-nav"
            onClick={() => setExpanded(!expanded)}
          />
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="ml-auto">
              <div
                className="collapse navbar-collapse show"
                id="navbarNavAltMarkup"
              >
                <div className="navbar-nav m-auto">
                  <ScrollLink
                    className="nav-link"
                    to="Features"
                    smooth={true}
                    duration={100}
                  >
                    Features
                  </ScrollLink>
                  <ScrollLink
                    className="nav-link"
                    to="Templates"
                    smooth={true}
                    duration={100}
                  >
                    Templates
                  </ScrollLink>
                  <ScrollLink
                    className="nav-link"
                    to="Reviews"
                    smooth={true}
                    duration={100}
                  >
                    Reviews
                  </ScrollLink>
                  {/* <ScrollLink
                    className="nav-link"
                    to="#"
                    smooth={true}
                    duration={100}
                  >
                    Learn
                  </ScrollLink> */}
                  {/* <ScrollLink
                    className="nav-link"
                    to="#"
                    smooth={true}
                    duration={100}
                  >
                    Tools
                  </ScrollLink> */}
                  <button
                    className="theme-toggle"
                    onClick={toggleTheme}
                    aria-label="Toggle theme"
                    title={`Switch to ${theme === "light" ? "dark" : "light"} mode`}
                  >
                    {theme === "light" ? (
                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z" />
                      </svg>
                    ) : (
                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <circle cx="12" cy="12" r="5" />
                        <line x1="12" y1="1" x2="12" y2="3" />
                        <line x1="12" y1="21" x2="12" y2="23" />
                        <line x1="4.22" y1="4.22" x2="5.64" y2="5.64" />
                        <line x1="18.36" y1="18.36" x2="19.78" y2="19.78" />
                        <line x1="1" y1="12" x2="3" y2="12" />
                        <line x1="21" y1="12" x2="23" y2="12" />
                        <line x1="4.22" y1="19.78" x2="5.64" y2="18.36" />
                        <line x1="18.36" y1="5.64" x2="19.78" y2="4.22" />
                      </svg>
                    )}
                  </button>
                  <div className="mr-2" style={{ height: "42px" }}>
                    <GoogleTranslate />
                  </div>
                </div>
              </div>
              <RedirectLink>
                <button
                  className="btn-get-started btn d-none d-lg-block d-flex justify-content-center align-content-center"
                  type="button"
                >
                  Create Sketches
                  <span className="pl-2 commanArrow">
                    <Image
                      src={Config.Icons.rightIconSvg}
                      alt="img-rightIcon"
                      name="rightIcon"
                      className="img-fuild"
                      loading="lazy"
                    />
                  </span>
                </button>
              </RedirectLink>
            </Nav>
          </Navbar.Collapse>
        </div>
      </Navbar>
    </>
  );
};

export default Header;
